<template>
  <ul class="phone-input">
    <li class="phone-input__select">
      <FlagsIndicatorSelectedComponent :selectedFlagPhone="selectedFlag" @changeIndicator="handleIndicator" />
    </li>
    <li class="phone-input__input">
      <span class="prefix">{{ prefix }}</span>
      <el-input
        :label="$t('stopsInfo.createStopInfo.phone')"
        :class="emptyFields['phone'] === true ? 'missing-field' : ''"
        v-model="contactPhone"
        placeholder="Phone Number"
        class="phone-input"
      />
      <el-input v-model="extension" placeholder="Ext" class="extension-input" />
    </li>
  </ul>
</template>
<script>
import FormatPhoneNumberWithoutPrefix from "@/Extend/FormatPhoneNumberWithoutPrefix";
import FlagsIndicatorSelectedComponent from "./FlagsIndicatorSelectedComponent.vue";

export default {
  name: "InputPhone",
  components: {
    FlagsIndicatorSelectedComponent,
  },
  props: {
    emptyFields: Object,
    phoneValue: String,
  },
  mixins: [FormatPhoneNumberWithoutPrefix],
  data() {
    return {
      selectedFlag: "",
      contactPhone: "",
      prefix: "+1",
      extension: "",
    };
  },
  watch: {
    contactPhone: {
      handler() {
        if (this.contactPhone !== "") {
          this.FormatterPhoneNumber();
        }
      },
    },
    extension() {
      if (this.extension !== "") {
        this.FormatterPhoneNumber();
      }
    },
    selectedFlag() {
      this.$emit("changeFlag", this.selectedFlag);
      this.updatePhonePrefix();
    },
  },
  created() {
    if (this.phoneValue) {
      this.prefix = this.extractPrefix(this.phoneValue);
      this.selectedFlag = this.prefix === "+52" ? "MEX" : "USA";
      this.contactPhone = this.phoneValue;
      this.extension = this.extractExtension(this.contactPhone);
    }
  },
  methods: {
    FormatterPhoneNumber() {
      const formattedPhoneNumber = this.FormatPhoneNumberWithoutPrefix(this.contactPhone, this.selectedFlag);
      if (formattedPhoneNumber) {
        this.contactPhone = formattedPhoneNumber;
        let phoneFormat;
        if (this.extension) {
          phoneFormat = `${this.contactPhone} ext ${this.extension}`;
        } else {
          phoneFormat = `${this.contactPhone}`;
        }
        this.$emit("changePhone", phoneFormat);
      }
    },
    handleIndicator(newIndicator) {
      this.selectedFlag = newIndicator;
    },
    updatePhonePrefix() {
      this.addPrefixInThePhoneInput();
    },
    extractExtension(phone) {
      if (!phone) return null;
      const match = phone.match(/(?:ext\.?|x\.?|#)\s*(\d+)/i);
      return match ? match[1] : null;
    },
    extractPrefix(phone) {
      if (!phone) return null;
      const cleaned = phone.replace(/\D/g, "");
      if (cleaned.startsWith("1")) {
        return "+1";
      }
      if (cleaned.startsWith("52")) {
        return "+52";
      }
      return null;
    },
    addPrefixInThePhoneInput() {
      this.prefix = "";
      if (this.selectedFlag === "MEX") {
        this.prefix = "+52";
      } else if (this.selectedFlag === "CAN" || this.selectedFlag === "USA") {
        this.prefix = "+1";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/components/RCComponents.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;

.phone-input {
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0px;
  height: 100%;
  width: 100%;
  list-style: none;
  &__select {
    width: 35%;
    ::v-deep .el-input__inner {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      border-right: none;
      &:focus {
        border-color: transparent;
      }
      &:hover {
        border-color: transparent;
      }
    }
  }
  &__input {
    display: flex;
    width: 100%;
    .phone-input {
      width: 80%;
      ::v-deep .el-input__inner {
        padding: 0px 30px;
      }
    }
    .extension-input {
      width: 20%;
      ::v-deep .el-input__inner {
        border-top-right-radius: 10px !important;
        border-bottom-right-radius: 10px !important;
      }
    }
    ::v-deep .el-input__inner {
      border: none;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      border-left: 1px solid $color-border-container;
    }
  }
}

.prefix {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding-left: 5px;
  z-index: 10;
  font-size: 14px;
}

.missing-field ::v-deep .el-input__inner {
  background: $missing-fields;
}
</style>
